export default "__VITE_ASSET__493c69b2__"